import { SafeHydrate } from "@/SafeHydrate";
import { BookOpen, LineChart, TrendingUp, Users, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
const courses = [{
  id: 1,
  title: "Fundamentos del Mercado de Valores",
  description: "Aprende los conceptos básicos del stock market estadounidense, tipos de acciones, y cómo funcionan las bolsas.",
  icon: BookOpen,
  duration: "Ver Videos",
  level: "Principiante"
}, {
  id: 2,
  title: "Análisis Técnico Avanzado",
  description: "Domina indicadores, patrones de velas japonesas y estrategias de trading para tomar decisiones informadas.",
  icon: LineChart,
  duration: "Ver Videos",
  level: "Intermedio"
}, {
  id: 3,
  title: "Estrategias de Inversión a Largo Plazo",
  description: "Construye un portafolio diversificado y aprende estrategias para invertir con visión a futuro.",
  icon: TrendingUp,
  duration: "Ver Videos",
  level: "Intermedio"
}, {
  id: 4,
  title: "Análisis Fundamental y Valoración",
  description: "Evalúa empresas mediante estados financieros, ratios y modelos de valoración para invertir con confianza.",
  icon: Users,
  duration: "Ver Videos",
  level: "Avanzado"
}];
export default function OurSpecializedCourses() {
  return <section className="py-16 lg:py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/courses_trading_charts_pattern.png)] opacity-4 pointer-events-none" />
      
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/85 to-background pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-transparent to-background/90 pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-br from-primary/3 via-transparent to-secondary/3 pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12 lg:mb-16 animate-fade-in-up">
          <h2 className="text-4xl lg:text-5xl font-semibold text-foreground mb-4">
            Ver Cursos Gratis Especializados
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Formación completa en inversión en el mercado estadounidense, diseñada para hispanohablantes con soporte personalizado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {courses.map((course, i) => {
          const Icon = course.icon;
          return <Card key={course.id} data-index={i} className="bg-black border border-gray-800 shadow-soft hover-lift transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <CardHeader>
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 size-12 rounded-md bg-primary/20 flex items-center justify-center">
                      <Icon className="size-6 text-primary" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-2xl mb-2 text-white">{course.title}</CardTitle>
                      <div className="flex gap-3 text-sm text-gray-400">
                        <span className="inline-flex items-center gap-1">
                          <span className="size-1.5 rounded-full bg-primary"></span>
                          {course.duration}
                        </span>
                        <span className="inline-flex items-center gap-1">
                          <span className="size-1.5 rounded-full bg-secondary"></span>
                          {course.level}
                        </span>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed mb-6 text-gray-300">
                    {course.description}
                  </CardDescription>
                  <Link to="/CursosPage">
                    <Button className="w-full sm:w-auto btn-primary">
                      Ver Detalles
                    </Button>
                  </Link>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to="/CursosPage">
            <Button size="lg" className="btn-primary hover-lift">
              Explora Nuestros Cursos
            </Button>
          </Link>
          <Link to="/webinar">
            <Button size="lg" className="relative overflow-hidden bg-gradient-to-br from-primary via-accent to-secondary text-white hover:shadow-strong hover:scale-105 transition-all duration-300 ease-out font-bold shadow-medium group">
              <span className="relative z-10 inline-flex items-center gap-2">
                Webinar
                <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-200%] group-hover:translate-x-[200%] transition-transform duration-700"></span>
              <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-yellow-400"></span>
            </Button>
          </Link>
          <Link to="/ContactoPage">
            <Button size="lg" variant="outline" className="hover-lift">
              ¿Tienes preguntas? Contáctanos
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}